const en = {
  app: { name: 'Salon Suite', tagline: 'Everything your salon needs, beautifully simple.' },
  nav: {
    dashboard: 'Dashboard',
    calendar: 'Calendar',
    walkins: 'Walk-ins',
    clients: 'Clients',
    pos: 'Point of sale',
    invoices: 'Invoices',
    services: 'Services',
    staff: 'Team',
    settings: 'Settings',
    platform: 'Platform',
    signOut: 'Sign out',
    bookingPage: 'Booking page',
  },
  common: {
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    create: 'Create',
    search: 'Search',
    loading: 'Loading…',
    back: 'Back',
    next: 'Next',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    none: 'None',
    optional: 'optional',
    branch: 'Branch',
    today: 'Today',
    status: 'Status',
    total: 'Total',
    actions: 'Actions',
    noResults: 'Nothing here yet',
    required: 'Required',
    language: 'Deutsch',
    theme: 'Toggle dark mode',
    export: 'Export CSV',
    import: 'Import CSV',
    print: 'Print',
    minutes: 'min',
    anyStylist: 'Any available stylist',
    page: 'Page {{page}} of {{total}}',
  },
  auth: {
    signIn: 'Sign in',
    signInTitle: 'Welcome back',
    signInSubtitle: 'Sign in to manage your salon',
    email: 'Email',
    password: 'Password',
    noAccount: 'New salon?',
    createAccount: 'Create your salon',
    haveAccount: 'Already have an account?',
    registerTitle: 'Open your salon on Salon Suite',
    salonName: 'Salon name',
    ownerName: 'Your name',
    phone: 'Phone (WhatsApp)',
  },
  status: {
    PENDING: 'Pending',
    CONFIRMED: 'Confirmed',
    CHECKED_IN: 'Checked in',
    IN_PROGRESS: 'In progress',
    COMPLETED: 'Completed',
    CANCELLED: 'Cancelled',
    NO_SHOW: 'No-show',
    ISSUED: 'Unpaid',
    PARTIALLY_PAID: 'Part paid',
    PAID: 'Paid',
    PARTIALLY_REFUNDED: 'Part refunded',
    REFUNDED: 'Refunded',
    VOID: 'Void',
    DRAFT: 'Draft',
    WAITING: 'Waiting',
    SERVING: 'Serving',
    DONE: 'Done',
    LEFT: 'Left',
  },
  dashboard: {
    greeting: 'Good to see you, {{name}}',
    todayRevenue: "Today's revenue",
    todayAppointments: "Today's appointments",
    remaining: '{{count}} still to come',
    periodRevenue: 'Revenue (30 days)',
    avgTicket: 'Average ticket',
    newClients: 'New clients (30 days)',
    noShowRate: 'No-show rate',
    revenueTrend: 'Revenue, last 30 days',
    topServices: 'Top services',
    upNext: 'Up next today',
    staffLeaderboard: 'Team performance',
    nothingNext: 'No more appointments today.',
    walkinsWaiting: '{{count}} walk-ins waiting',
  },
  calendar: {
    day: 'Day',
    week: 'Week',
    newAppointment: 'New appointment',
    allStaff: 'All stylists',
    dragHint: 'Drag to reschedule · click an empty slot to book',
    moved: 'Appointment moved',
    allergy: 'Allergy on file',
  },
  appointment: {
    client: 'Client',
    services: 'Services',
    stylist: 'Stylist',
    date: 'Date',
    time: 'Time',
    notes: 'Notes',
    outsideHours: 'Allow booking outside working hours',
    notify: 'Send confirmation to client',
    addService: 'Add service',
    pickTime: 'Pick a time',
    customTime: 'Custom time',
    noSlots: 'No free slots on this day. Try another date or stylist.',
    book: 'Book appointment',
    confirmAction: 'Confirm',
    checkIn: 'Check in',
    start: 'Start service',
    complete: 'Complete',
    noShow: 'No-show',
    cancelAppt: 'Cancel appointment',
    reason: 'Reason',
    waiveFee: 'Waive late-cancellation fee',
    checkout: 'Checkout',
    reschedule: 'Reschedule',
    reference: 'Ref',
    deposit: 'Deposit',
    fee: 'Cancellation fee',
  },
  booking: {
    title: 'Book an appointment',
    chooseBranch: 'Choose a location',
    chooseServices: 'What would you like?',
    chooseStylist: 'Choose your stylist',
    chooseTime: 'Pick a date & time',
    yourDetails: 'Your details',
    review: 'Review & confirm',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Mobile number (WhatsApp)',
    email: 'Email',
    notes: 'Anything we should know?',
    optIn: 'Send me offers and reminders on WhatsApp',
    confirmBooking: 'Confirm booking',
    booked: "You're booked!",
    bookedText: 'We sent a confirmation to your WhatsApp. See you soon.',
    manage: 'Manage booking',
    bookAnother: 'Book another',
    selected: '{{count}} selected',
    duration: 'Duration',
    from: 'from',
    morning: 'Morning',
    afternoon: 'Afternoon',
    evening: 'Evening',
    depositNote: 'A deposit of {{amount}} secures this booking.',
    payDeposit: 'Pay deposit',
    policy: 'Free cancellation up to {{hours}} hours before your appointment.',
    cancelBooking: 'Cancel booking',
    cancelled: 'This booking has been cancelled.',
    callSalon: 'To change this booking please call the salon.',
    bookNow: 'Book now',
    yourBooking: 'Your booking',
    changeTime: 'Change time',
  },
  clients: {
    title: 'Clients',
    newClient: 'New client',
    searchPlaceholder: 'Search name, phone or email',
    visits: 'Visits',
    spent: 'Total spent',
    lastVisit: 'Last visit',
    allergy: 'Allergy',
    notes: 'Notes',
    photos: 'Photos',
    history: 'History',
    consent: 'Forms',
    overview: 'Profile',
    addNote: 'Add note',
    upload: 'Upload photo',
    sign: 'Fill & sign',
    firstName: 'First name',
    lastName: 'Last name',
    phone: 'Phone',
    email: 'Email',
    gender: 'Gender',
    birthday: 'Birthday',
    anniversary: 'Anniversary',
    optIn: 'Marketing opt-in',
    language: 'Preferred language',
    tags: 'Tags',
    importDone: 'Imported: {{created}} new, {{updated}} updated, {{errors}} errors',
  },
  pos: {
    title: 'Point of sale',
    cart: 'Current sale',
    addItem: 'Add',
    customItem: 'Custom item',
    discount: 'Discount',
    tip: 'Tip',
    tax: 'Tax',
    subtotal: 'Subtotal',
    charge: 'Charge {{amount}}',
    payment: 'Take payment',
    method: 'Method',
    amount: 'Amount',
    tendered: 'Cash received',
    change: 'Change due',
    split: 'Split payment',
    remaining: 'Remaining',
    paid: 'Payment received',
    sendReceipt: 'Send receipt on WhatsApp/email',
    newSale: 'New sale',
    register: 'Cash register',
    openRegister: 'Open register',
    closeRegister: 'Close register',
    float: 'Opening float',
    counted: 'Counted cash',
    expected: 'Expected cash',
    variance: 'Variance',
    registerClosed: 'Register is closed',
    refund: 'Refund',
    void: 'Void invoice',
    walkInSale: 'Walk-in (no client)',
    CASH: 'Cash',
    CARD: 'Card',
    WALLET: 'JazzCash / Easypaisa',
    QR: 'QR',
    BANK_TRANSFER: 'Bank transfer',
    ONLINE: 'Online',
  },
  walkins: {
    title: 'Walk-in queue',
    add: 'Add walk-in',
    wait: '~{{min}} min wait',
    noEstimate: 'No stylist available',
    serve: 'Start',
    done: 'Done',
    left: 'Left',
    empty: 'No one waiting. Nice!',
  },
  services: { title: 'Services', newService: 'New service', newCategory: 'New category', duration: 'Duration', buffer: 'Buffer', price: 'Price', deposit: 'Deposit', online: 'Bookable online', followUp: 'Follow-up after (weeks)', stylists: 'Who performs it' },
  staff: { title: 'Team', newMember: 'Add team member', schedule: 'Weekly schedule', leave: 'Leave', role: 'Role', branches: 'Branches', bookable: 'Takes bookings', requestLeave: 'Request leave', approve: 'Approve', reject: 'Reject', dayOff: 'Day off', breaks: 'Breaks', addBreak: 'Add break' },
  settings: { title: 'Settings', general: 'Salon', booking: 'Booking rules', branches: 'Branches', templates: 'Messages', roles: 'Roles', forms: 'Consent forms', widget: 'Website widget', audit: 'Audit log', log: 'Message log' },
  roles: { SUPER_ADMIN: 'Platform admin', OWNER: 'Owner', MANAGER: 'Manager', RECEPTIONIST: 'Receptionist', STYLIST: 'Stylist', CLIENT: 'Client' },
  days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
};

export default en;
export type Dictionary = typeof en;
